import { Avatar } from '@workspace/ui/components/avatar';
import { User } from 'lucide-react';
import type { Member } from '~/routes/_authenticated/persons/-api/types';

interface MentionDropdownProps {
  members: any[];
  onSelect: (member: Member) => void;
  selectedIndex: number;
}

export const MentionDropdown = ({
  members,
  onSelect,
  selectedIndex,
}: MentionDropdownProps) => {
  if (members.length === 0) {
    return (
      <div className="bg-popover text-popover-foreground border rounded-md shadow-lg p-2 max-h-48 overflow-y-scroll z-[9999] relative scrollbar-thumb-rounded-full scrollbar-track-rounded-full scrollbar scrollbar-thumb-primary-foreground scrollbar-track-background">
        <div className="flex items-center gap-2 px-2 py-1.5 text-sm text-muted-foreground">
          <User className="h-4 w-4" />
          <span>No se encontraron personas</span>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-popover text-popover-foreground border rounded-md shadow-lg p-1 max-h-48 overflow-y-scroll z-[9999] relative flex flex-col-reverse scrollbar-thumb-rounded-full scrollbar-track-rounded-full scrollbar scrollbar-thumb-primary-foreground scrollbar-track-background">
      {members.map((member, index) => {
        const reversedIndex = members.length - 1 - index;
        return (
          <button
            key={member.id}
            type="button"
            data-index={reversedIndex}
            className={`flex items-center gap-2 px-2 py-1.5 text-sm cursor-pointer rounded-sm w-full text-left ${
              reversedIndex === selectedIndex
                ? 'bg-accent text-accent-foreground'
                : 'hover:bg-accent hover:text-accent-foreground'
            }`}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onSelect(member);
            }}
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            <Avatar className="h-6 w-6">
              <div className="flex items-center justify-center w-full h-full bg-primary text-primary-foreground text-xs font-medium">
                {member.name.charAt(0).toUpperCase()}
              </div>
            </Avatar>
            <div className="flex-1 min-w-0">
              <div className="font-medium truncate">{member.name}</div>
              {member.email && (
                <div className="text-xs text-muted-foreground truncate">
                  {member.email}
                </div>
              )}
            </div>
            <div className="text-xs text-muted-foreground">{member.type}</div>
          </button>
        );
      })}
    </div>
  );
};
